import React from "react";
import { CommonUtils } from "../../utilities";
import Lock from "../SVG/Lock";
import RedLock from "../SVG/RedLock";
import RedUnlock from "../SVG/RedUnlock";
import Unlock from "../SVG/Unlock";
import "./PasswordInput.scss";
import PasswordInputProps from "./PasswordInput.types";

const PasswordInput = ({
  placeholder,
  className = "",
  isPasswordVisible,
  color = "primary",
  onIconClick,
  lock = false,
  ...props
}: any) => {
  const commonInputProp = {
    ...props,
    type: isPasswordVisible ? "text" : "password",
    placeholder: `${placeholder}`,
    className: `input-${color} ${className}`,
    required: true,
  };
  return (
    <div className="pInput-wrapper">
      <input {...commonInputProp} maxLength={14} />
      {/* display lock color based on password error */}
      {isPasswordVisible ? (
        <>
          {!lock ? (
            <RedUnlock onClickHandle={onIconClick} />
          ) : (
            <Unlock onClickHandle={onIconClick} />
          )}
        </>
      ) : (
        <>
          {lock ? (
            <Lock onClickHandle={onIconClick} />
          ) : (
            <RedLock onClickHandle={onIconClick} />
          )}
        </>
      )}
    </div>
  );
};

export default PasswordInput;
